<ng-container *ngIf="isActive">
  <svg
    class="preloader-schematic"
    [ngClass]="{ paragraph: schematicType === preloaderSchematicType.PARAGRAPH }"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    *ngIf="schematicType !== preloaderSchematicType.NONE"
  >
    <defs>
      <linearGradient id="shine{{ idSuffix }}" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop *ngFor="let i of gradientAniConfig" attr.offset="{{ i.offset }}%" stop-color="#cbc8c1" stop-opacity="0.2">
          <animate
            attributeName="stop-opacity"
            attr.values="{{ i.values.join(';') }}"
            dur="4.5s"
            repeatCount="indefinite"
          ></animate>
        </stop>
      </linearGradient>
      <pattern
        *ngIf="schematicType === preloaderSchematicType.PARAGRAPH"
        id="paragraph{{ idSuffix }}"
        x="0"
        y="0"
        width="100%"
        height="16.5rem"
        patternUnits="userSpaceOnUse"
      >
        <rect
          class="s-rect r1"
          attr.fill="url(#shine{{ idSuffix }})"
          attr.x="{{ dir.isLtr ? 0 : 30 }}%"
          y="0"
          width="70%"
          height="1.375rem"
        ></rect>
        <rect
          *ngFor="let i of rectCount; let even = even"
          attr.class="s-rect r{{ i + 2 }}"
          attr.fill="url(#shine{{ idSuffix }})"
          attr.x="{{ dir.isLtr ? 0 : even ? 50 : 55 }}%"
          attr.y="{{ 2.063 + i * 1.375 }}rem"
          attr.width="{{ even ? 50 : 45 }}%"
          height="0.688rem"
        ></rect>
      </pattern>
    </defs>
    <rect
      attr.fill="url(#{{ (schematicType === preloaderSchematicType.PARAGRAPH ? 'paragraph' : 'shine') + idSuffix }})"
      width="100%"
      height="100%"
      shape-rendering="optimizeSpeed"
    />
  </svg>
  <div class="lod-container">
    <div
      class="lod-box"
      [ngClass]="{ 'lod-box-sm': size === preloaderSize.S, 'lod-box-xs': size === preloaderSize.XS }"
    >
      <div class="lod"></div>
      <div class="lod l2"></div>
      <div class="lod l3"></div>
    </div>
  </div>
</ng-container>
